import React, { Fragment } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import Sidebar from "../../layout/Sidebar/index";
import BusinessAuth from "./BusinessAuth";
import AdminAuth from "./AdminAuth";

const PostAuthLayout = () => {
  const isSidebarOpen = useSelector((state) => state.layout.isSidebarOpen);

  return (
    <Fragment>
      <Sidebar />
      <main
        className={` overflow-y-auto h-[100vh] pt-[90px] transition-all duration-300  bg-[var(--scondary-bg-color)]  ${isSidebarOpen ? 'ml-64' : 'ml-0 md:ml-16'
          }`}
      >
        <div >
          <AdminAuth />
          <BusinessAuth />
        </div>
      </main>
    </Fragment>
  );
};

export default PostAuthLayout;
